import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';
import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';

export type TextSettingsParams = {
  headerTitle: SettingsParamType.Text;
  headerDescription: SettingsParamType.Text;
  addToCartButtonText: SettingsParamType.Text;
};

/**
 * `metadata` exposes these params in the widget's editor manifest
 * (`editorElement.data`), which is what Aria reads and edits in Studio 2.
 * Params without `metadata` are dropped from the manifest.
 * `displayName` is the field label in the Studio 2 "Edit Text" panel.
 */
export const textSettingsParams = createSettingsParams<TextSettingsParams>({
  headerTitle: {
    type: SettingsParamType.Text,
    getDefaultValue: () => '',
    metadata: ({ t }) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('header_olo.default.title'),
      },
      dataItemManifestData: {
        displayName: t('app.settings.text.title'),
      },
      ai: {
        description:
          'Title text shown at the top of the Online Orders widget header. Empty value shows the default title.',
      },
    }),
  },
  headerDescription: {
    type: SettingsParamType.Text,
    getDefaultValue: () => '',
    metadata: ({ t }) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('header_olo.default.description'),
      },
      dataItemManifestData: {
        displayName: t('app.settings.text.description'),
      },
      ai: {
        description:
          'Description text shown under the title in the Online Orders widget header. Empty value shows the default description.',
      },
    }),
  },
  addToCartButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => '',
    metadata: ({ t }) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('menu_olo.addToCartButton.default-text'),
      },
      dataItemManifestData: {
        displayName: t('app.settings.design-tab.add-to-cart.title'),
      },
      ai: {
        description:
          'Text of the add to cart button on menu items. Empty value shows the default button text.',
      },
    }),
  },
});
